/**
 * Night Warrior Theme — Main JavaScript Entry
 * Styles are compiled separately via Sass. Stimulus owns Turbo-safe lifecycle.
 */
import { ThemeManager } from "./modules/theme.js"
import { SidebarManager } from "./modules/sidebar.js"
import { CommandPalette } from "./modules/command-palette.js"
import { ToastManager } from "./modules/toast.js"
import { SearchOverlay } from "./modules/search.js"
import { KeyboardShortcuts } from "./modules/keyboard.js"
import { LanguageManager } from "./modules/language.js"

window.NightWarrior = { ThemeManager, SidebarManager, CommandPalette, ToastManager, SearchOverlay, LanguageManager }

export { ThemeManager, SidebarManager, CommandPalette, ToastManager, SearchOverlay, LanguageManager }
